import { MetadataMomentPlatform } from '../gql/graphql';

export enum DeviceType {
  IPHONE = 'iphone',
  ANDROID = 'android',
  MAC = 'mac',
  OTHER = 'other',
}

const getDeviceOverride = (): DeviceType | null => {
  const params = new URLSearchParams(window.location.search);
  const override = params.get('deviceType')?.toLowerCase();
  if (override === 'iphone') return DeviceType.IPHONE;
  if (override === 'android') return DeviceType.ANDROID;
  if (override === 'other') return DeviceType.OTHER;
  return null;
};

export const detectDevice = (): DeviceType => {
  const override = getDeviceOverride();
  if (override) return override;

  const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;

  // iPhone detection only (excludes iPad/iPod for wallet functionality)
  if (/iPhone/.test(userAgent) && !(window as any).MSStream) {
    return DeviceType.IPHONE;
  }

  if (/Mac/i.test(userAgent)) {
    return DeviceType.MAC;
  }

  // Android detection
  if (/android/i.test(userAgent)) {
    return DeviceType.ANDROID;
  }

  return DeviceType.OTHER;
};

export const detectPlatform = (): MetadataMomentPlatform => {
  const device = detectDevice();
  switch (device) {
    case DeviceType.IPHONE:
      return MetadataMomentPlatform.Ios;
    case DeviceType.ANDROID:
      return MetadataMomentPlatform.Android;
    default:
      return MetadataMomentPlatform.Web;
  }
};
